import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';

import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { HBox, VBox } from '../../../../components/Box';
import { Row } from '../../../../components/List';
import { Cell } from '../Cell';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { BaseCellComp } from '../BaseCellComp';
import { performAction } from '../../actions';

import { selectVehicle } from '../../../Vehicles/selectors';
import { selectUserId, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { getRemarkType } from '../helpers/getRemarkType';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import styles from './Hooi_Default.module.css';

import { DoubleCheck } from '../../../../containers/App/Components/DoubleCheck/DoubleCheck';
import { VehicleEditableField } from '../../../Vehicles/components/VehicleEditableField';
import { VehicleProductTasksSection } from '../../../Vehicles/components/VehicleProductTasksSection';
import { setVehicleProperty } from '../../../Vehicles/actions';
import { VehicleLocationCard } from '../../../Vehicles/components/VehicleLocationCard';
import { VehicleDocumentsCard } from '../../../Vehicles/components/CardDocuments';

const TASK_REMARK_TYPE = 'HOOI_NEW_task_diagnose_external';
const Container = styled.div`
  .modal-inner {
  }

  .manco-list > div {
  }
`;

let todaydate = new Date().toISOString();

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_NEW_diagnose_externalComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  get vehicle() {
    return this.props.cell.vehicle;
  }
  get doubleCheckProps() {
    return ['HOOI_NEW_order_licenseplate', 'HOOI_NEW_attach_licenseplate'];
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  disableConfirmation() {
    let disable = false;

    this.doubleCheckProps.forEach(prop => {
      if (!this.props.vehicle[prop]) {
        disable = true;
      }
    });

    return disable;
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.column.label}>
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer kanbanCell />
          </div>

          <Container>
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>
                  <DoubleCheck
                    key={'HOOI_NEW_make_transport_diagnose_external'}
                    name={'HOOI_NEW_make_transport_diagnose_external'}
                    vehicle={this.props.vehicle}
                  />
                </Cell>
              </Row>
              {this.propertyValue('HOOI_NEW_make_transport_diagnose_external') === '1' && (
               <><VehicleProductTasksSection vehicleId={this.vehicle?.id} fromKanban />
             <Row>
                    <Cell>
                      <DoubleCheck
                        key={'HOOI_NEW_loaded_for_transport_and_change_location_diagnose_external'}
                        name={'HOOI_NEW_loaded_for_transport_and_change_location_diagnose_external'}
                        vehicle={this.props.vehicle} />
                    </Cell>
                  </Row></>)}
                  
                  {this.propertyValue('HOOI_NEW_loaded_for_transport_and_change_location_diagnose_external') === '1' && (
                   <>
                                   < VehicleLocationCard vehicleId={this.vehicle?.id} fromKanban />
                   
                  <Row>
                    <Cell>
                      <DoubleCheck
                        key={'HOOI_NEW_external_diagnosis_performed'}
                        name={'HOOI_NEW_external_diagnosis_performed'}
                        vehicle={this.props.vehicle} />
                    </Cell>
                  </Row><Row>
                    <Cell>Resultaat / advies diagnose:
                      {this.props.workRemarks ? (
                        <Loader small />
                      ) : (
                        <KanbanVehicleRemarks
                          key={'modal'}
                          fullWidth={true}
                          taskName={TASK_REMARK_TYPE}
                          kanbanBoardLabel={this.props.board?.label}
                          vehicleId={this.vehicle.id}
                          loggedUserId={this.props.loggedInUserId} />
                      )}
                    </Cell>
                  </Row><Row>
                    <Cell>
                      <DoubleCheck
                        key={'HOOI_NEW_repair_agreed_and_commissioned'}
                        name={'HOOI_NEW_repair_agreed_and_commissioned'}
                        vehicle={this.props.vehicle} />
                    </Cell>
                  </Row></>
                )}
              {this.propertyValue('HOOI_NEW_repair_agreed_and_commissioned') === '1' && (
              <Row>
                <Cell>
                  <DoubleCheck
                    key={'HOOI_NEW_make_task_external_repair'}
                    name={'HOOI_NEW_make_task_external_repair'}
                    vehicle={this.props.vehicle}
                  />
                </Cell>
              </Row>
              )}
              {this.propertyValue('HOOI_NEW_repair_agreed_and_commissioned') === '0' && (
              <Row>
                <Cell>
                  <DoubleCheck
                    key={'HOOI_NEW_return_transport_order_created'}
                    name={'HOOI_NEW_return_transport_order_created'}
                    vehicle={this.props.vehicle}
                  />
                </Cell>
              </Row>
              )}
                              <VehicleDocumentsCard vehicle={this.props.vehicle}  />
              

              <HBox className="mt-3">
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    key={'modal'}
                    fullWidth={true}
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
              </HBox>
            </VBox>
          </Container>
        </WithVehicle>
        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            // disabled={this.disableConfirmation()}
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />

          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} kanbanCell />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_NEW_diagnose_externalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_NEW_diagnose_external = compose(withConnect, withRouter)(HOOI_NEW_diagnose_externalComp);
